import React, { useContext } from "react";
import { VideoPlayerContext } from "../context/VideoPlayerContext";
import { FaPlay, FaPause } from "react-icons/fa";
import Link from "next/link";
import { useRouter } from "next/router";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // Import Tippy.js CSS

const GlobalVideoPlayer = () => {
  const {
    isPlaying,
    setIsPlaying,
    currentTime,
    duration
  } = useContext(VideoPlayerContext);

  const handlePlayPause = (e) => {
    e.stopPropagation(); // Prevent event bubbling if necessary
    setIsPlaying(!isPlaying);
  };

  const router = useRouter();
  const { asPath } = router;
  const liveRoutes = [
    '/en/tv/',
    '/fr/tv/',
    '/en/radio/',
    '/fr/radio/',
  ];

  const isLive = liveRoutes.some(route => asPath.startsWith(route));

  const melodiesRoutes = [
    '/en/music/raqtaq',
    '/fr/music/raqtaq',
  ];

  const isMelo = melodiesRoutes.some(route => asPath.startsWith(route));

  const siteVersion = router.pathname.substring(0, 3);

  // Format time function
  const formatTime = (time) => {
    if (isNaN(time) || time === Infinity || time === 0 || time > 10800) return "∞";
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);
    return hours > 0
      ? `${hours}:${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`
      : `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <Link href="#" onClick={(e) => { e.preventDefault(); handlePlayPause(); }}>
      <div className="nav-bot-menu" onClick={handlePlayPause}>
          <div>
            {isPlaying ? <FaPause /> : <FaPlay />}
          </div>
        <div className="nav-bot-text">
          {isPlaying ? (
            <>
              <span>
                {isLive ? 'Live' : (isMelo ? (siteVersion === `/fr` ? 'Mélodies' : 'Melodies') : `${formatTime(currentTime)}/${formatTime(duration)}`)}
              </span>
            </>
          ) : (
            "Play"
          )}
        </div>
      </div>
    </Link>
  );
};

export default GlobalVideoPlayer;
